import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import PFStatusUpdateModalUI from './PFStatusUpdateModalUI.js'

class PFStatusUpdateModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,
            submitted: false,

            processingFeeStatus: '',

            tdsAmount: '',

            waivePercentage: '',
        }
    }

    render() {
        const allStatuses = [
            { key: 'unpaid', value: 'unpaid' },
            { key: 'waived', value: 'waived' },
        ]

        const currentStatus =
            this.props.part === '1'
                ? this.props.loan.procFee1Status
                : this.props.loan.procFee2Status

        const processingFeeStatusList = allStatuses.filter(
            status => status.key !== currentStatus
        )

        return (
            <PFStatusUpdateModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={this.setErrorList}

                updateMode={this.props.updateMode}
                submitted={this.state.submitted}

                onSubmit={this.onSubmit}
                onCancelClick={this.props.onCancelClick}

                processingFeeStatus={this.state.processingFeeStatus}
                onProcessingFeeStatusChange={(e) =>
                    this.setState({ processingFeeStatus: e.target.value })
                }
                processingFeeStatusList={processingFeeStatusList}

                tdsAmount={this.state.tdsAmount}
                onTdsAmountChange={(e) =>
                    this.setState({ tdsAmount: e.target.value })
                }

                waivePercentage={this.state.waivePercentage}
                onwaivePercentageChange={this.onwaivePercentageChange}

            />
        )
    }

    componentDidMount() {
        Modal.setAppElement('body')
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.updateMode && this.props.updateMode) {
            this.initializeForm()
        }
    }

    initializeForm = () => {
        const allStatuses = [
            { key: 'unpaid', value: 'unpaid' },
            { key: 'waived', value: 'waived' },
        ]

        const currentStatus =
            this.props.part === '1'
                ? this.props.loan.procFee1Status
                : this.props.loan.procFee2Status

        const filtered = allStatuses.filter(s => s.key !== currentStatus)

        this.setState({
            processingFeeStatus: filtered.length > 0 ? filtered[0].key : '',
            tdsAmount: '',
            waivePercentage: '',
            errorList: null,
            successMsg: null,
            submitted: false
        })
    }

    onwaivePercentageChange = (e) => {
        const value = e.target.value

        if (value === '' || /^\d{0,3}(\.\d{0,2})?$/.test(value)) {
            this.setState({
                waivePercentage: value
            })
        }
    }

    onSubmit = () => {
        if (this.state.submitted) return

        let errorList = []

        if (!this.state.processingFeeStatus) {
            errorList.push('Processing Fee Status is required')
        }

        const val = this.state.waivePercentage

        if (!val) {
            errorList.push('Waive Percentage is required')
        } else if (isNaN(val)) {
            errorList.push('Waive Percentage must be numeric')
        } else if (Number(val) < 0 || Number(val) > 100) {
            errorList.push('Waive Percentage must be between 0 and 100')
        }

        if (errorList.length > 0) {
            this.setState({ errorList })
            return
        }

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        const part = this.props.part
        const waivePercentage = this.state.waivePercentage

        const url = `/api/su/loans/${this.props.loan.loanId}/processingFees/${part}/status?waivePercentage=${waivePercentage}`

        RestApiUtils.put(
            this.props.context,
            url,
            this.onSubmitCallback,
            {
                procFeeStatus: this.state.processingFeeStatus,
                tdsAmountF: this.state.tdsAmount
            }
        )
    }

    onSubmitCallback = (response) => {
        let errorList = []

        if (response && response.errorList) {
            response.errorList.forEach(error => {
                errorList.push(error.message)
            })
        }

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (!response.errorList || response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({ successMsg: null })
                this.props.onCancelClick()
                this.props.onRefreshClick()
            }, 1000)
        }
    }

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
    }
}

export default withRouter(PFStatusUpdateModalSF)